import type { ReactNode } from 'react';
import { cn } from './cn';

/** Standard page padding wrapper. `bleed` removes padding for full-bleed maps. */
export function PageContainer({
  children,
  className,
  bleed,
}: {
  children: ReactNode;
  className?: string;
  bleed?: boolean;
}) {
  return <div className={cn(bleed ? 'h-full' : 'p-5', className)}>{children}</div>;
}
